// USER TYPES
export const ADD_TOKEN = "ADD_TOKEN"
export const CHANGE_USER = "CHANGE_USER"
export const ADD_TIMER = "ADD_TIMER"